import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { path } from 'router/sections';
import { TableExt, TableInfo, GridBox } from 'libs/ui';
import { getTableParams } from './grid.params';
import { CashboxPhotos } from './cashbox-photos';
import { Qr } from './blocks/qr';

export const CashboxGrid = (props) => {
  const { count, summ, entries, className, theme, getXlsAction } = props;
  const history = useHistory();
  const { t } = useTranslation();
  const [showQr, setShowQr] = useState(false);
  const [row, setRow] = useState({});

  // items
  const items = Object.keys(entries).map((key) => entries[key]);

  /**
   * go to park session card
   * @param {*} row
   */
  const showParkingCardAction = (row) => {
    history.push(`${path('stay')}?id=${row.stay_id}`);
  };

  /**
   * go to subscription with filter
   * @param {*} row
   */
  const showSubscriptionAction = (row) => {
    history.push(path('subscription'), {
      filter: {
        mean_id: row.mean_id,
      },
    });
  };

  /**
   * toggle qr window
   */
  const showQrWindow = () => {
    setShowQr((val) => !val);
  };

  // actions
  const actions = [];
  actions.push({ title: t('buttons.Перейти в карточку парковки'), action: showParkingCardAction, isVisible: (row) => !!row.stay_id });

  actions.push({ title: t('buttons.Перейти в абонементы'), action: showSubscriptionAction, isVisible: (row) => row.mean_type === 'subscription' && !!row.result });

  actions.push({
    title: t('buttons.QR чека'),
    action: (row) => {
      setRow(row);
      showQrWindow();
    },
    isVisible: (row) => !!row.data?.check_qrcode,
  });

  // top actions
  const topActions = [];
  if (count) {
    getXlsAction(topActions);
  }

  const tableParams = useMemo(() => getTableParams(t), []);

  return (
    <GridBox>
      <TableInfo theme={theme} count={count} summ={summ} actions={topActions} />

      <TableExt
        theme={theme}
        title={t('sections.Кассовые операции')}
        rows={{ count, items }}
        actions={actions}
        className={className}
        refresh={props.refresh}
        onRowClickCmp={CashboxPhotos}
        {...tableParams}
      />

      {showQr && <Qr close={showQrWindow} id={row.id} />}
    </GridBox>
  );
};
